/* eslint-disable */

import React, { useEffect, useMemo, useRef } from 'react'
import { withStyles } from '@aura/components/styles'
import { Button,Container, Grid, Link } from '@aura/components'
import CustomLoader from '../../../../components/custom-loader'
import PropTypes from 'prop-types'
import RegistrationContainer from '../../../../components/new-registration-container'
import factorTypes from '../../../../constants/client-servicing-factor-types'
import { useTranslation } from 'react-i18next'

import qrCodeStatuses from '../../../../constants/fetch-qr-code-status'


import styles from './styles'

const Component = ({
    classes,
    data,
    error,
    factorType,
    initQRCode,
    onBack,
    onNext,
    onQRCodeCannotScan,
    provider,
    qrCodeStatus,
    title,
    verbiage
}) => {
    const { t: translate } = useTranslation()

    const subTitle = {
        'gotp': translate('mfaEnrollment.gotp'),
        'opush':translate('mfaEnrollment.opush'),
        'ootp':translate('mfaEnrollment.ootp')
    }

    

    useEffect(() => {
        if (factorType && provider) {
            initQRCode({ factorType, provider })
        }
    }, [])

    const { href } = data

       const footerContent = useMemo(() => {
        const footerButtons = [
            {
                className: classes.backButton,
                disabled: false,
                label: translate('back'),
                onClick: onBack,
                variant: 'text'
            },
            {
                className: `${classes.nextButton} `,
                label: translate('next'),
                onClick: onNext
            }
        ]

        return (
            <Grid className={classes.buttonContainer}>
                {footerButtons.map((button, index) => (
                    <Button
                        key={`footer-button-${index}`}
                        className={button.className}
                        color='primary'
                        disabled={button.disabled}
                        onClick={button.onClick}
                        variant={button.variant}
                    >
                        {button.label}
                    </Button>
                ))}
            </Grid>
        )
    }, [ classes.buttonContainer, classes.cancelButton, classes.nextButton, classes.nextButtonDisabled, translate, onBack, onNext ])


    const handleCannotScan = (event) => {
        event.preventDefault()
        onQRCodeCannotScan()
    }
       const mainContent = useMemo(() => (
            <>
                <div className={classes.container}>
                    { qrCodeStatus === qrCodeStatuses.PENDING
                        ? <Container className={classes.customLoader}>
                                        <CustomLoader
                                            label={translate('loading')}
                                        />
                                    </Container>
                        : <>
                         <div className={classes.introText}>
                <p className={classes.subTitle}>{subTitle[factorType]}</p>
            </div>
                          <Container className={classes.setupIcon}>
                              <img src={href} alt="QR Code" style={{ width: '110px', height: '110px' }} />
                          </Container>
                            {factorType !== factorTypes.PUSH
                                ? <Link
                                    classes={{ root: classes.link }}
                                    href=""
                                    onClick={handleCannotScan}
                                    underline="always">{translate('cantScan')}
                                </Link>
                                : <></>}
                        </> }
                    {  qrCodeStatus === qrCodeStatuses.PENDING ? <></> : <>
                        <div className={classes.contentDivider}></div>            
                        <span className={classes.error}>{error && translate('oktaApiResponse.' + `${error}`)}</span>  
                    </>}
                    </div>
            {/* </Form> */}
                { qrCodeStatus === qrCodeStatuses.PENDING ? <></> :
                <div className={classes.helpText}>
                    <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
                </div>
        }
            </>
        ), [classes, translate, qrCodeStatus, href, factorType, error, data, handleCannotScan])
    

    return (
        <RegistrationContainer {...{ title: translate(`authenticatorOptions.${title}`), verbiage: translate(`authenticatorOptions.${verbiage}`), footerActions : qrCodeStatus !== qrCodeStatuses.PENDING && footerContent, mainContent }}>
           
        </RegistrationContainer>
    )
}

Component.displayName = 'QRCode'

Component.defaultProps = {
    data: {
        href: ''
    }
}

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object,
        stepper: PropTypes.object,
        stepperContainer: PropTypes.object
    }),
    data: PropTypes.object,
    error: PropTypes.object,
    initQRCode: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onQRCodeCannotScan:  PropTypes.func.isRequired,
    qrCodeStatus: PropTypes.string.isRequired,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

const StyledComponent = withStyles(Component, styles)

export default StyledComponent
